import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M853.333333,421.808455 L853.333333,528.475122 L106.666667,528.494575 L106.666667,1711.52488 L1493.33333,1711.52488 L1493.33333,1168.47512 L1600,1168.47512 L1600,1711.52488 C1600,1770.43525 1552.24371,1818.19154 1493.33333,1818.19154 L106.666667,1818.19154 C47.7562934,1818.19154 0,1770.43525 0,1711.52488 L0,528.494575 C0,469.584202 47.7562934,421.827908 106.666667,421.827908 L853.333333,421.808455 Z M563.592063,800.019761 L563.592063,1439.99969 L1096.85829,1120.00973 L563.592063,800.019761 Z M1600,101.808455 L1600,421.808455 L1920,421.808455 L1920,528.475122 L1600,528.475122 L1600,848.475122 L1493.33333,848.475122 L1493.33333,528.475122 L1173.33333,528.475122 L1173.33333,421.808455 L1493.33333,421.808455 L1493.33333,101.808455 L1600,101.808455 Z",
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: "1"
});

var IconAddMediaLine = /*#__PURE__*/function (_Component) {
  _inherits(IconAddMediaLine, _Component);

  var _super = _createSuper(IconAddMediaLine);

  function IconAddMediaLine() {
    _classCallCheck(this, IconAddMediaLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconAddMediaLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconAddMedia",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconAddMediaLine.displayName = "IconAddMediaLine";
  return IconAddMediaLine;
}(Component);

IconAddMediaLine.glyphName = 'add-media';
IconAddMediaLine.variant = 'Line';
IconAddMediaLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconAddMediaLine;
export { IconAddMediaLine };